import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { LinearProgress, Stack, Typography } from '@mui/material';

export const RqmtCoverageCard = () => {
  return (
    <DashboardCard
      title="Requirement Coverage"
      description="Displays how many of the requirements mapped to the selected tests were met on the latest run"
      icon={fas.faListCheck}
    >
      {(data) => {
        const { met, total } = data.requirements;
        const coverage = total > 0 ? (met / total) * 100 : 0;

        return (
          <Stack height="100%">
            <Stack direction="row" alignItems="baseline" gap={1}>
              <Typography variant="h3" sx={{ fontWeight: 700 }}>
                {met}
              </Typography>
              <Typography variant="h5" color="text.secondary">
                / {total}
              </Typography>
            </Stack>

            <LinearProgress
              variant="determinate"
              value={coverage}
              sx={{
                minHeight: 8,
                display: 'block',
                borderRadius: 1,
                bgcolor: 'grey.200',
                '& .MuiLinearProgress-bar': {
                  bgcolor: coverage === 100 ? 'success.main' : 'primary.main',
                  borderRadius: 1,
                },
              }}
            />

            <Typography variant="caption" color="text.secondary">
              {coverage.toFixed(1)}% coverage
            </Typography>
          </Stack>
        );
      }}
    </DashboardCard>
  );
};
